import React from "react";

import marked from "marked";

class FurtherReadingListNoteItem extends React.Component {
  render() {
    return (
      <li className="further-reading__list-item further-reading__note-item">
        <div className="further-reading__details">
          <div className="further-reading__description" dangerouslySetInnerHTML={{__html: marked(this.props.item.data.Description)}} />
        </div>
      </li>
    );
  }
}

export default FurtherReadingListNoteItem;